import { createApi } from '@reduxjs/toolkit/query/react';
import { createIbkDomainBaseQuery } from '../api/createIbkBaseQuery';
export const customIbkBaseQuery = createIbkDomainBaseQuery();
export const ibkApi = createApi({
    reducerPath: 'ibkApi',
    baseQuery: customIbkBaseQuery,
    tagTypes: ['EmissorOrders', 'Emissor'],
    endpoints: () => ({}),
});
